import { render, staticRenderFns } from "./GroupMemberCategory.vue?vue&type=template&id=0e51bfc3&scoped=true&"
import script from "./GroupMemberCategory.vue?vue&type=script&lang=js&"
export * from "./GroupMemberCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51bfc3",
  null
  
)

export default component.exports